'use strict';

require('modaal/dist/js/modaal');